export default {
      id: "defaultDoc-usage",
      viewBox: "0 0 64 64",
      url: __webpack_public_path__ + "img/icons.7315c2cd.svg#defaultDoc",
      toString: function () {
        return this.url;
      }
    }